export function DotDivider(): JSX.Element {
  return <span className='seam-dot-divider'>•</span>
}
